import React from "react";
import { useTranslation } from "react-i18next";
import LandingHeader from "../components/Landing/sections/LandingHeader.jsx";
import LandingNav from "../components/Landing/sections/LandingNav.jsx";
import LandingFooter from "../components/Landing/sections/LandingFooter.jsx";
import "../styles/new-landing.css";

import { useEffect } from "react";
import useRestoreScroll from "../hooks/useRestoreScroll.js";

const partners = [
  {
    id: "al-ahsa",
    translationKey: "partners.list.alAhsa",
    logo: "/Partners/Al-Ahsa.png",
    website: "https://www.livestocksa.org/ar",
  },
];

const Partners = () => {
  const { t } = useTranslation();
  useRestoreScroll();

  useEffect(() => {
    document.body.style.overflow = "";
    document.body.style.overflowY = "";
    return () => {
      document.body.style.overflow = "";
      document.body.style.overflowY = "";
    };
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <LandingHeader />
      <LandingNav />
      <div className="partners-container">
        <div className="partners-header">
          <h1>{t("partners.header.title")}</h1>
          <p>{t("partners.header.subtitle")}</p>
        </div>
        <div className="partners-grid">
          {partners.map((partner) => (
            <a
              key={partner.id}
              href={partner.website}
              target="_blank"
              rel="noopener noreferrer"
              className="partner-card"
              aria-label={t(`${partner.translationKey}.name`)}
            >
              <div className="partner-logo-wrapper">
                <img
                  src={partner.logo}
                  alt={`${t(`${partner.translationKey}.name`)} logo`}
                  className="partner-logo"
                />
              </div>
              <h3 className="partner-name">
                {t(`${partner.translationKey}.name`)}
              </h3>
            </a>
          ))}
        </div>
      </div>
      <LandingFooter />
    </>
  );
};

export default Partners;
